/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useLayoutEffect as r,useEffect as o}from"react";import{isBrowser as t}from"./is-browser.js";const m=t?r:o;export{m as useIsomorphicLayoutEffect};
//# sourceMappingURL=use-isomorphic-effect.js.map
